import React, { useState } from "react";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import CartItems from "../commons/preOrder/CartItems";
import axios from "axios";

import "../style/Checkout.css";
import { useDispatch, useSelector } from "react-redux";
import { addComasToPrice } from "../utils/PriceFormat";
import { Button, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router";
import { getShoppingCart } from "../state/shoppingCart";
import { getItemCart } from "../state/itemCart";
import { Link } from "react-router-dom";
import { HiArrowNarrowLeft } from "react-icons/hi";

const GENERAL_STYLE_OPTIONS = {
  base: {
    iconColor: "#909090",
    color: "#000",
    fontWeight: 500,
    fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
    fontSize: "16px",
    fontSmoothing: "antialiased",
    ":-webkit-autofill": { color: "#000" },
    "::placeholder": { color: "#909090" },
  },
  invalid: {
    iconColor: "#EA4C46",
    color: "#EA4C46",
  },
};

const GENERAL_OPTIONS = {
  style: GENERAL_STYLE_OPTIONS,
};

const CARD_NUMBER_OPTIONS = {
  showIcon: true,
  placeholder: "4242 4242 4242 4242",
  iconStyle: "solid",
  style: GENERAL_STYLE_OPTIONS,
};

const PaymentForm = () => {
  const user = useSelector((state) => state.user);
  const shoppingCart = useSelector((state) => state.shoppingCart);
  const cartItems = useSelector((state) => state.itemCarts);
  const [cardError, setCardError] = useState("");
  const [updatingCart, setUpdatingCart] = useState(false);
  const [loadingBuy, setLoadingBuy] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({
    firstname: user.name,
    lastname: user.lastname,
    address: "",
    email: user.email,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!shippingInfo.address) {
      setCardError("Please provide an address");
      return;
    }
    setLoadingBuy(true);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });

    if (!error) {
      try {
        const { id } = paymentMethod;
        const totalAmount = parseInt(parseFloat(shoppingCart.total) * 0.5);
        const response = await axios.post(
          "https://the-green-shop.herokuapp.com/payment",
          {
            amount: totalAmount,
            id,
          }
        );

        if (response.data.success) {
          console.log(`SUCCESFUL PAYMENT`);

          const order = await axios.post(
            `https://the-green-shop.herokuapp.com/api/orderDetail/createOrderDetail`,
            {
              UserId: user.id,
              total: shoppingCart.total,
            }
          );

          const orderId = order.data.id;

          await Promise.all(
            cartItems.map((item) => {
              return axios.post(
                `https://the-green-shop.herokuapp.com/api/orderItem/add`,
                {
                  price: item.product.price,
                  quantity: item.quantity,
                  productId: item.productId,
                  orderdetailId: order.data.id,
                }
              );
            })
          );

          await Promise.all(
            cartItems.map((item) => {
              return axios.delete(
                `https://the-green-shop.herokuapp.com/api/itemCart/remove/${item.id}`
              );
            })
          );

          await axios.delete(
            `https://the-green-shop.herokuapp.com/api/shoppingCart/${shoppingCart.id}`
          );

          const { payload } = await dispatch(getShoppingCart());
          navigate(`/orderDetails/${orderId}`);
          await dispatch(getItemCart(payload.id));
          setLoadingBuy(false);
        }
      } catch (error) {
        console.error("Error", error);
      }
    } else {
      setLoadingBuy(false);
      setCardError(error.message);
      console.error(error.message);
    }
  };

  return (
    <div className="main-checkout">
      <div className="checkout-div">
        <>
          <div className="billinfo-div">
            <div className="shipping-info">
              <h4>Shipping Information</h4>
              <form id="payment-form">
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <label>First Name</label>
                  <input
                    type="text"
                    className="StripeElement"
                    placeholder="First Name"
                    value={shippingInfo.firstname}
                    onChange={(e) => {
                      setShippingInfo({
                        ...shippingInfo,
                        firstname: e.target.value,
                      });
                    }}
                  />
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Last Name</label>

                    <input
                      type="text"
                      className="StripeElement"
                      placeholder="Last Name"
                      value={shippingInfo.lastname}
                      onChange={(e) => {
                        setShippingInfo({
                          ...shippingInfo,
                          lastname: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Address</label>

                    <input
                      type="text"
                      className="StripeElement"
                      placeholder="Address"
                      value={shippingInfo.address}
                      onChange={(e) => {
                        setShippingInfo({
                          ...shippingInfo,
                          address: e.target.value,
                        });
                      }}
                      required
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Email</label>

                    <input
                      type="text"
                      className="StripeElement"
                      placeholder="Email"
                      value={shippingInfo.email}
                      onChange={(e) => {
                        setShippingInfo({
                          ...shippingInfo,
                          email: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              </form>
            </div>

            <div className="shipping-info card-form-div">
              <h4>Payment Details</h4>
              <form onSubmit={handleSubmit} className="card-form">
                <fieldset className="FormGroup">
                  {/* <CardElement options={CARD_OPTIONS} /> */}
                  <label>Card Number</label>
                  <div className="FormRow">
                    <CardNumberElement options={CARD_NUMBER_OPTIONS} />
                  </div>
                  <div className="FormRow">
                    <div className="FormColumn" style={{ marginRight: "20px" }}>
                      <label>Expiration</label>
                      <CardExpiryElement options={GENERAL_OPTIONS} />
                    </div>
                    <div className="FormColumn">
                      <label>CVC</label>
                      <CardCvcElement options={GENERAL_OPTIONS} />
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>

          <div className="orderContainer2 cartitems-div">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h4>Cart Items</h4>
              <Link to="/products/all" style={{ textDecoration: "none" }}>
                <Button
                  style={{ display: "flex", alignItems: "center", margin: 0 }}
                  variant="outline-primary"
                >
                  <HiArrowNarrowLeft style={{ marginRight: "10px" }} />
                  Continue Shopping
                </Button>
              </Link>
            </div>
            <CartItems
              updatingCart={updatingCart}
              setUpdatingCart={setUpdatingCart}
            />
            <div style={{ alignSelf: "flex-end" }}>
              Total:{" "}
              <span style={{ fontSize: "1.2em" }}>
                {updatingCart && (
                  <Spinner
                    animation="border"
                    color="white"
                    style={{ width: "1.2em", height: "1.2em" }}
                  />
                )}
                {!updatingCart && (
                  <>{"$ " + addComasToPrice(shoppingCart.total)}</>
                )}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
                marginTop: "20px",
              }}
            >
              <span style={{ display: "block", color: "#EA4C46" }}>
                {cardError}
              </span>
              <Button
                type="submit"
                form="payment-form"
                onClick={handleSubmit}
                variant="success"
                style={{ margin: 0, width: "200px" }}
              >
                {loadingBuy && (
                  <Spinner
                    animation="border"
                    color="white"
                    style={{
                      width: "1.2em",
                      height: "1.2em",
                      fontWeight: "normal",
                    }}
                  />
                )}
                {!loadingBuy && "Checkout"}
              </Button>
            </div>
          </div>
        </>
      </div>
    </div>
  );
};

export default PaymentForm;
